import React from 'react';
import { Paper, Typography, Box, Link, CircularProgress, Alert } from '@mui/material';

const Profile = ({ profile, loading }) => {
  if (loading) {
    return (
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      </Paper>
    );
  }

  if (!profile) {
    return (
      <Paper sx={{ p: 3, mb: 3 }}>
        <Alert severity="error">
          Failed to load profile information. Please try refreshing the page.
        </Alert>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">{profile.fullName || 'Name not provided'}</Typography>
        <Typography variant="body1" color="text.secondary">
          {profile.location || 'Location not provided'}
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="body1">
          <strong>Email:</strong>{' '}
          {profile.email ? (
            <Link href={`mailto:${profile.email}`} color="inherit">
              {profile.email}
            </Link>
          ) : (
            'Email not provided'
          )}
        </Typography>
        
        <Typography variant="body1">
          <strong>Phone:</strong>{' '}
          {profile.phone ? (
            <Link href={`tel:${profile.phone}`} color="inherit">
              {profile.phone}
            </Link>
          ) : (
            'Phone not provided'
          )}
        </Typography>

        {profile.linkedinUrl && (
          <Typography variant="body1">
            <strong>LinkedIn:</strong>{' '}
            <Link href={profile.linkedinUrl} target="_blank" rel="noopener noreferrer">
              {profile.linkedinUrl}
            </Link>
          </Typography>
        )}

        {profile.personalWebsite && (
          <Typography variant="body1">
            <strong>Website:</strong>{' '}
            <Link href={profile.personalWebsite} target="_blank" rel="noopener noreferrer">
              {profile.personalWebsite}
            </Link>
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default Profile; 